"use client";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";
import React from "react";

type Props = { children: React.ReactNode };

let ErrorBoundary: React.ComponentType<Props> = ({ children }) => <>{children}</>;

if (typeof window !== "undefined" && process.env.NEXT_PUBLIC_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
    appVersion: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    plugins: [new BugsnagPluginReact()],
    onError: (event) => {
      if (event.errors[0]?.errorMessage?.includes("webkit.messageHandlers")) return false;
    },
  });
  BugsnagPerformance.start({ apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY });
  ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React) as React.ComponentType<Props>;
}

export default function BugsnagProvider({ children }: Props) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}
